<nz-layout class="h-100">
  <!-- ENCABEZADO -->
  <nz-page-header [nzTitle]="nzBreadcrumb">
    <ng-template #nzBreadcrumb>
      <div class="flex-center-between title-container">
        <nz-breadcrumb class="flex-center">
          <button style="margin-right: 6px" nz-button nzType="text" nzShape="circle" nzSize="default" (click)="goBack()">
            <app-st-icon class="text-dark" [bold]="true" name="arrow_back"></app-st-icon>
          </button>
          <ng-container>
            <nz-breadcrumb-item>
              <span>Búsqueda</span>
            </nz-breadcrumb-item>
          </ng-container>
        </nz-breadcrumb>
      </div>
    </ng-template>

    <nz-page-header-extra>
      <app-global-searchbar></app-global-searchbar>
    </nz-page-header-extra>
  </nz-page-header>

  <!-- CONTENEDOR PRINCIPAL -->
  <nz-layout class="content-wrapper">
    <div class="filters-container flex gap-150 no-scroll-bar">
      @for (filter of filters; track filter) {
        <div (click)="onFilterSelect(filter)" class="st-badget"
             [class.large]="!(screenService.isMobile$ | async)"
             [ngClass]="filter.active ? (filter.class || 'black') : 'subtle-grey'">
          <app-st-icon [name]="filter.icon"></app-st-icon>
          <label>{{filter.name}}</label>
        </div>
      }
    </div>

    @if (loading) {
      <nz-skeleton [nzParagraph]="{ rows: 6 }" [nzActive]="true"></nz-skeleton>
    } @else {
      <app-global-search-results class="search-results"
                                 [isSmallMode]="false"
                                 [showServiceOrders]="filters[0].active || filters[1].active"
                                 [showServices]="filters[0].active || filters[2].active"
                                 [showProjects]="filters[0].active || filters[3].active"
      ></app-global-search-results>
    }
  </nz-layout>

</nz-layout>

